module.exports = __webpack_public_path__ + "img/notifications-bell.32ed4340.png";